import type { CreditCardActions, CreditCardState } from "./types";

const INITIAL_STATE: CreditCardState = {
  loading: false,
  data: {
    banner: {
      field_banner: "",
      field_cc_description: "",
      field_cc_link: "",
      field_link_title: "",
      title: "",
    },
    creditCardContent: {
      advisories: [],
      benefits: [],
      promos: [],
      services: [],
      steps: [],
    },
    benefit: [],
    cardList: [],
  },
  error: false,
  refreshing: false,
};

export default (
  state: CreditCardState = INITIAL_STATE,
  action: CreditCardActions
): CreditCardState => {
  switch (action.type) {
    case "REQUEST_CREDIT_CARDS_DATA": {
      return {
        ...state,
        loading: true,
        error: false,
        refreshing: false,
      };
    }
    case "REQUEST_CREDIT_CARDS_DATA_SUCCESS": {
      return {
        data: action.payload,
        loading: false,
        refreshing: false,
        error: false,
      };
    }
    case "REQUEST_CREDIT_CARDS_DATA_FAILED": {
      return {
        ...state,
        loading: false,
        refreshing: false,
        error: true,
      };
    }
    default:
      return state;
  }
};
